import gql from 'graphql-tag';
import { categoriesAsTreePartial, categoryFieldsFragment } from './categories';

export const RECOMMENDED_ARTICLES_SLICE_FRAGMENT = `
	recommendedArticlesSlice {
		_id
		publishedBy {
			_id
			name
			type
		}
		title
		summary
		categories {
			_id
			name
		}
		premiumChannelDetails {
			_id
			name
		}
		rootCategories {
			_id
			name
		}
		publishDate
		isPremium
		isPremiumActive
		isLocked
		canSeeFullVersion
	}
`;

export const ARTICLES = gql`
	query getArticles($params: ArticlesInput) {
		articles(params: $params) {
			articles {
				_id
				author
				title
				publishedBy { _id name type }
				contributors { _id name }
				categories { _id name }
				tags { _id name }
				state
				created
				version
				lastEdited
				publishDate
				views
				promotionalContent {
					_id
					name
				}
				isPremium
				isPremiumActive
				premiumExpiryOffset
				premiumChannel
			}
			total
		}
	}`;

export const ADD_ARTICLES = gql`
mutation addArticle($item: ArticleInputAdd) {
	addArticle(item: $item) {
            author
            title
            html
            publishedBy { _id name }
            contributors { _id name }
            categories { _id name }
            tags { _id name }
            state
            version
			publishDate
			isPremium
			premiumExpiryOffset
			premiumChannel
	}
}
`;

export const EDIT_ARTICLE = gql`
mutation editArticle($item: ArticleInputEdit) {
	editArticle(item: $item) {
            _id
            author
            title
            html
            publishedBy { _id name }
            contributors { _id name }
            categories { _id name }
            tags { _id name }
            state
            version
			publishDate
			isPremium
			premiumExpiryOffset
			premiumChannel
	}
}
`;

export const ARCHIVE_ARTICLE = gql`
mutation archiveArticle($item: ArticleArchive) {
  archiveArticle(item: $item) {
            _id
            state
	}
}
`;

export const PUBLISH_ADD = gql`
mutation publishAdd($item: ArticleInputAdd) {
	publishAdd(item: $item) {
            author
            title
            html
            publishedBy { _id name }
            contributors { _id name }
            categories { _id name }
            tags { _id name }
            state
            version
			publishDate
			isPremium
			premiumExpiryOffset
			premiumChannel
	}
}
`;

export const PUBLISH_EDIT = gql`
mutation publishEdit($item: ArticleInputEdit) {
	publishEdit(item: $item) {
            _id
            author
            title
            html
            publishedBy { _id name }
            contributors { _id name }
            categories { _id name }
            tags { _id name }
            state
            version
			publishDate
			isPremium
			premiumExpiryOffset
			premiumChannel
	}
}
`;

export const GET_BROWSE_STAT = gql`
query getBrowseStat($categoryId: ID) {
	getBrowseStat(categoryId: $categoryId){
		tags {
			_id
			name
		}
		desks {
			_id
			name
		}
		trendingArticles {
			_id
			title
		}
	}
}
`;

export const GET_STATS_BY_CHANNEL = gql`
query getStatsByChannel($query: ChannelStatsQuery!) {
	getStatsByChannel(query: $query){
		trendingArticles {
			_id
			title
		}
	}
}
`;

export const GET_BROWSE_STAT_WITH_SUBSCIPTION = gql`
query getBrowseStat($categoryId: ID!) {
	getBrowseStat(categoryId: $categoryId){
		tags {
			_id
			name
		}
		desks {
			_id
			name
		}
		trendingArticles {
			_id
			title
		}
	}
	isSubscribedTo(id: $categoryId)
}
`;

export const GET_MONTHS_LIST = gql`
query getLastMonthsWithArticles{
  getLastMonthsWithArticles
  {
    year
    month
  }
}`;

export const GET_ARTICLE = gql`
query articlePage($id: ID) {
	document: findArticleById(id: $id) {
		_id
		author
		title
		html
		publishedBy { _id name type }
		contributors { _id name }
		categories { _id name }
		tags { _id name }
		state
		created
		summary
		version
		lastEdited
		publishDate
		wasPublishedPreviously
		promotionalContentIds
		promotionalContent { _id name }
		isPremium
		isPremiumActive
		premiumExpiryOffset
		premiumChannel
		showWatermark
		displayInChartSection
		isPinned
		isTimeless
	}
}`;

export const GET_CHARTS_ARTICLES = gql`
	query getChartsArticles($premiumChannelId: ID) {
		getChartsArticles(premiumChannelId: $premiumChannelId) {
			_id
			title
			summary
		}
	}
`;

export const ALL_STATIC = gql`
query static {
	tags { _id name }
	desks {
		_id
		name
		contributors {
			_id
			name
			scopes
		}
	}
	users: contributors { _id scopes name }
	promotionalContent: existentPromotionalContent { _id name link articleImage expiryDate }
	${categoriesAsTreePartial}
}
${categoryFieldsFragment}`;

export const GET_TEMPLATE = gql`
query templatePage($id: ID) {
	document: findTemplateById(id: $id) {
		_id
		title
		html
		contributors { _id name }
		categories { _id name }
		tags { _id name }
		publishedBy { _id name type }
		premiumChannel
	}
}`;


export const GET_SUBSCRIBERS_COUNT = gql`
query getSubscribersCount($channelId: ID) {
  getSubscribersCount(channelId: $channelId){
    count
  }
}`;
